import { money, number } from '../../util/formatters'
import React from 'react'
import { Calculation } from './Calculation'
import { get, getSuffix } from '../../util/kdp_cols'
import { MarketplaceI } from '../../util/marketplaces'

interface RpcCellProps {
    rpc: number
    sales: number
    clicks: number
    marketplace?: MarketplaceI
}

export const RpcCell = (v: RpcCellProps, extra: any) => {
    const suffix = getSuffix(extra.col?.key)
    const g = (key: string) => get(v, key, suffix)
    const m = v.marketplace ?? null
    const lines = [
        { description: 'Sales', value: money(g('sales'), m) ?? '' },
        { description: '÷ Clicks', value: number(g('clicks'), 0) ?? '' },
        { description: 'RPC', value: money(g('rpc'), m) ?? '' },
    ]

    return <Calculation lines={lines}>{money(g('rpc'), m)}</Calculation>
}

interface BlendedRpcCellProps {
    blended_rpc: number
    blended_profit: number
    clicks: number
    marketplace?: MarketplaceI
}

export const BlendedRpcCell = ({
    blended_rpc,
    blended_profit,
    clicks,
    marketplace,
}: BlendedRpcCellProps) => {
    const m = marketplace ?? null
    const lines = [
        { description: 'Blended Profit', value: money(blended_profit, m) ?? '' },
        { description: '÷ Clicks', value: number(clicks, 0) ?? '' },
        { description: 'Blended RPC', value: money(blended_rpc, m) ?? '' },
    ]

    return <Calculation lines={lines}>{money(blended_rpc, m)}</Calculation>
}
